import { useCallback, useEffect, useMemo, useState } from 'react'

import { integrationService } from '../IntegrationService'
import type {
  IntegrationActionResult,
  IntegrationCategory,
  IntegrationRecord,
  IntegrationStatus,
} from '../IntegrationTypes'

export function useIntegrationCenter() {
  const [items, setItems] = useState<IntegrationRecord[]>(() => integrationService.list())
  const [categoria, setCategoria] = useState<IntegrationCategory | 'Todas'>('Todas')
  const [status, setStatus] = useState<IntegrationStatus | 'Todos'>('Todos')
  const [query, setQuery] = useState('')
  const [toast, setToast] = useState<string | null>(null)
  const [selectedId, setSelectedId] = useState<string | null>(null)

  const reload = useCallback(() => {
    setItems(integrationService.list())
  }, [])

  useEffect(() => {
    reload()
  }, [reload])

  const filtered = useMemo(() => {
    const q = query.trim().toLowerCase()
    return items.filter((item) => {
      if (categoria !== 'Todas' && item.categoria !== categoria) return false
      if (status !== 'Todos' && item.status !== status) return false
      if (!q) return true
      return (
        item.nome.toLowerCase().includes(q) ||
        item.categoria.toLowerCase().includes(q) ||
        item.tipo.toLowerCase().includes(q) ||
        item.id.toLowerCase().includes(q)
      )
    })
  }, [items, categoria, status, query])

  function runAction(
    action: 'edit' | 'test' | 'connect' | 'disconnect' | 'logs',
    id: string,
  ): IntegrationActionResult {
    const result =
      action === 'edit'
        ? integrationService.edit(id)
        : action === 'test'
          ? integrationService.test(id)
          : action === 'connect'
            ? integrationService.connect(id)
            : action === 'disconnect'
              ? integrationService.disconnect(id)
              : integrationService.logs(id)

    reload()
    setSelectedId(id)
    setToast(result.message)
    return result
  }

  return {
    items: filtered,
    total: items.length,
    categoria,
    setCategoria,
    status,
    setStatus,
    query,
    setQuery,
    toast,
    setToast,
    selectedId,
    runAction,
    reload,
  }
}
